import React from "react";

const EnterIcon = ({
  width = "28",
  height = "29",
  active = false,
  activeColor = "#1D5AB9",
  inActiveColor = "#969998",
  color = active ? activeColor : inActiveColor,
}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 20 13"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M1.05805 4.08518C0.896643 4.12259 0.805544 4.28121 0.854577 4.43947L1.13178 5.33421C1.18081 5.49247 1.35141 5.59045 1.51282 5.55304L2.08402 5.42067V12.4433C2.08402 12.609 2.21833 12.7433 2.38402 12.7433H3.98037C4.14606 12.7433 4.28037 12.609 4.28037 12.4433V4.91169L19.1394 1.46825C19.3008 1.43085 19.3919 1.27223 19.3429 1.11396L19.0657 0.219228C19.0167 0.0609641 18.8461 -0.0370117 18.6847 0.000392937L4.28037 3.33844V3.16564C4.28037 2.99995 4.14606 2.86564 3.98037 2.86564H2.38402C2.21833 2.86564 2.08402 2.99995 2.08402 3.16564V3.84743L1.05805 4.08518ZM3.48866 4.38532C3.48866 4.55318 3.33132 4.68925 3.13724 4.68925C2.94316 4.68925 2.78582 4.55318 2.78582 4.38532C2.78582 4.21747 2.94316 4.08139 3.13724 4.08139C3.33132 4.08139 3.48866 4.21747 3.48866 4.38532ZM4.90648 3.43409L5.68571 3.24545L5.41068 4.42448L4.63146 4.61312L4.90648 3.43409ZM7.26733 2.86551L6.4881 3.05415L6.21308 4.23318L6.99231 4.04454L7.26733 2.86551ZM8.06973 2.67421L8.84896 2.48556L8.57393 3.6646L7.79471 3.85324L8.06973 2.67421ZM10.43 2.10575L9.65075 2.2944L9.37573 3.47343L10.155 3.28478L10.43 2.10575ZM11.2318 1.91446L12.011 1.72581L11.736 2.90484L10.9568 3.09349L11.2318 1.91446ZM13.5926 1.34587L12.8134 1.53452L12.5384 2.71355L13.3176 2.5249L13.5926 1.34587ZM14.2188 1.23071L14.998 1.04206L14.723 2.22109L13.9438 2.40974L14.2188 1.23071ZM16.5803 0.737991L15.801 0.926636L15.526 2.10567L16.3053 1.91702L16.5803 0.737991ZM17.3821 0.54676L18.1613 0.358115L17.8863 1.53715L17.107 1.72579L17.3821 0.54676Z"
        fill={color}
      />
      <path
        d="M7.10008 7.65993C6.85495 7.84544 6.85495 8.14669 7.10008 8.3322L10.2377 10.7066C10.4829 10.8921 10.881 10.8921 11.1261 10.7066C11.3712 10.5211 11.3712 10.2199 11.1261 10.0344L9.05719 8.47021H15.0736C15.4207 8.47021 15.7012 8.258 15.7012 7.99532C15.7012 7.73265 15.4207 7.52044 15.0736 7.52044L9.05915 7.52044L11.1241 5.95627C11.3693 5.77077 11.3693 5.46951 11.1241 5.28401C10.879 5.09851 10.4809 5.09851 10.2358 5.28401L7.09812 7.65845L7.10008 7.65993Z"
        fill={color}
      />
    </svg>
  );
};

export default EnterIcon;
